/**
 * Created by Administrator on 2018/1/2.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
@Component({
  templateUrl:'./settingActivityEdit.html'
})

export class SettingActivityEdit implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private location:Location,
    private fileupload:FileUpload
  ){}

  private data:any={
    "id": "",
    "titleEn": "",
    "titleTc": "",
    "startTime":"",
    "endTime": "",
    "imageEn": "",
    "imageTc": "",
    "productId":"",
    "selectedItems":[],
    "desc": "",
  }

  private id:number = 0;

  private isCreate:boolean=false;
  public settings= {
                    singleSelection: false,
                    text:"Select Countries",
                    selectAllText:'Select All',
                    unSelectAllText:'UnSelect All',
                    enableSearchFilter: true,
                    classes:"myclass custom-class"
  }


  public signData = [];
  private imagePath:string='';

  private desc:string='<p></p>';
  private onReady():void{
    this.desc = this.data.desc;
  }

  private onChange():void{
    this.data.desc = this.desc;
  }

  ngOnInit(): void {
    this.getSignData();
    this.getPath();
    this.route.params.subscribe((params) => {
      this.id=params['id'];
      this.id=this.data.id;
    });

    if(this.id!=0){
      this.getData();
    }else {
      this.isCreate = true;
    }
  }


//获取下拉列表
  private getSignData():void{
    this.HttpService.getData(API.sign_in_select).then(res=>{
      // this.signData = res.data;
      for (let i of res.data) {
        this.signData.push({id:i.id,itemName:i.name})
      }
    })
  }


  // private getProductData(){
  //   this.HttpService.getData(API.product,{
  //     pageNumber: this.page.pageNumber-1,
  //     pageSize:this.page.pageSize,
  //   }).then(res=>{
  //     this.data=res.data;
  //     for (let i=0;i<this.data.content.length;i++){
  //       if(this.data.content[i].image!=''){
  //         this.data.content[i].image = this.imagePath+this.data.content[i].image;
  //       }
  //     }
  //   });
  // }
//获取全部数据
  private getData():void{
    this.HttpService.getData(API.sign_in_product+'/'+this.id).then(res=>{
      this.data = res.data;
    })
  }


  // 获取图片路径
  private showImageEn:boolean = false;
  private showImageTc:boolean = false;
  private tempPath:string=API.getTemp;
  private upload(name:string){
    let self=this;
    this.fileupload.upload(function (res) {
      let temRes=JSON.parse(res);
      if(temRes.status.code==0){
        switch (name){
          case 'imageEn':self.showImageEn=true;break;
          case 'imageTc':self.showImageTc=true;break;
        }
        self.data[name]=temRes.data.fileName;
      }
    });
  }

  private getPath():void{
    this.HttpService.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        console.log(res.data)
      })
  }

  private submit():void{
    this.HttpService.postData(API.sign_in_product_createOrUpdate,this.data).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
      }else{
        alert(data.status.message);
      }
    });
  }

}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/activity/settingActivityEdit.component.ts